import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
export const WelderProgressHeaderStyled = styled(Box).attrs({
  ml: { sm: '600' },
  pt: { sm: '450' },
})`
  position: relative;
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    border-radius: ${theme.radii[200]};
  `}
`;
export const TreeLineStyled = styled.div`
  position: absolute;
  height: 100%;
  width: 1px;
  top: 0;
  bottom: 0;
  left: -14px;
  background-color: ${({ theme }) => theme.colors.grey['300']};
`;
export const RodRequestHeaderStyled = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 128px 1fr 1fr 1fr;
  align-items: center;
  justify-items: center;
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    color: ${theme.colors.black};
    margin-left: ${theme.spacings[600]};
    padding-top: ${theme.spacings[200]};
    padding-bottom: ${theme.spacings[200]};
  `}
`;

interface TabButtonStyledProps {
  isSelected?: boolean;
}
export const TabButtonStyled = styled(Box).attrs({})<TabButtonStyledProps>`
  cursor: pointer;
  ${({ isSelected, theme }) => css`
    background-color: ${isSelected ? theme.colors.white : theme.colors.grey[200]};
    font-weight: ${isSelected ? '600' : 'normal'};
    border-top-left-radius: ${theme.radii[200]};
    border-top-right-radius: ${theme.radii[200]};
  `}
`;

export const WelderProgressTreeItemContainerStyled = styled.div`
  position: relative;
  display: grid;
  align-items: center;
  justify-items: center;
  grid-template-columns: 128px 1fr 1fr 1fr;
`;
